const DetentionConfigurationConstants = {
  // Types of Detentions
  type: [
    {
      id: 1,
      from: 'LOADING',
      to: 'CUTOFF',
    },
    {
      id: 2,
      from: 'UNLOADING',
      to: 'CUTOFF',
    },
  ],
  // Current detention active from the above list
  allowedTypes: [1, 2],

  defaultValue: {
    detentions: [
      { detention_type: 2, duration: 0 },
      { detention_type: 1, duration: 0 },
    ],
  },
};

const detentionDefaults = {
  threshold_time: '11:59',
  start_time: '00:00',
};

module.exports = { DetentionConfigurationConstants, detentionDefaults };
